import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import awsConfig from "../aws-exports";
import "./Dashboard.css";

const Login = () => {
  const navigate = useNavigate();
  const [redirected, setRedirected] = useState(false);

  const exchangeCodeForToken = async (code) => {
    console.log("Exchanging code for token...");
    try {
      const response = await fetch(
        `https://${awsConfig.authority}/oauth2/token`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            grant_type: "authorization_code",
            client_id: awsConfig.client_id,
            redirect_uri: awsConfig.redirect_uri,
            code,
          }),
        }
      );

      const data = await response.json();
      console.log("Token exchange response:", data);

      if (response.ok && data.access_token) {
        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("id_token", data.id_token || "");
        localStorage.setItem("refresh_token", data.refresh_token || "");
        console.log("Token stored successfully. Redirecting to dashboard...");
        setRedirected(true);
        navigate("/dashboard", { replace: true });
      } else {
        console.error("Token exchange failed:", data);
        alert("Failed to log in. Please try again.");
      }
    } catch (error) {
      console.error("Error exchanging token:", error);
      alert("An error occurred during login. Please try again.");
    }
  };

  useEffect(() => {
    if (redirected) return;

    const token = localStorage.getItem("access_token");

    if (token) {
      console.log("Access token found. Redirecting to dashboard...");
      setRedirected(true);
      navigate("/dashboard", { replace: true });
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (code) {
      console.log("Authorization code found:", code);
      if (!localStorage.getItem("token_exchange_in_progress")) {
        localStorage.setItem("token_exchange_in_progress", "true");
        exchangeCodeForToken(code).finally(() => {
          localStorage.removeItem("token_exchange_in_progress");
        });
      }
    } else {
      console.log("No authorization code found. Staying on login page.");
    }
  }, [navigate, redirected]);

  const handleLogin = () => {
    const loginUrl = `https://${awsConfig.authority}/oauth2/authorize?client_id=${awsConfig.client_id}&response_type=${awsConfig.response_type}&scope=${encodeURIComponent(
      awsConfig.scope
    )}&redirect_uri=${encodeURIComponent(awsConfig.redirect_uri)}`;
    console.log("Redirecting to Cognito login page:", loginUrl);
    window.location.href = loginUrl;
  };

  return (
    <div className="dashboard-container">
      <main className="content">
        <h2>Login</h2>
        <p>Please log in to access your account.</p>
        <Button variant="contained" color="primary" onClick={handleLogin}>
          Sign in
        </Button>
      </main>
    </div>
  );
};

export default Login;
